<template>
  <!-- App.vue -->
  <v-app>
    <v-navigation-drawer v-model="drawer" dark app>
      <v-list dense>
        <v-subheader>Modulos</v-subheader>
        <SideMenuAdministrator v-if="menu_role_id==1"></SideMenuAdministrator>
        <SideMenuManagementControl v-if="menu_role_id==2"></SideMenuManagementControl>
        <SideMenuAdministrative v-if="menu_role_id==3"></SideMenuAdministrative>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <CloseSession></CloseSession>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar color="#0FCBBF" dense app>
      <v-app-bar-nav-icon
        color="white"
        @click="drawer = drawer == true ? false : true"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">KAIROS</v-toolbar-title>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <relogin></relogin>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <notification/>
        <countdown-files/>
        <slot name="contenido"></slot>
      </v-container>
    </v-main>

    <v-footer padless inset app>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>Servicio de Salud Magallanes &copy; </strong>
        Versión {{global}}
      </v-col>
    </v-footer>
  </v-app>
</template>
<script>
import CountdownFiles from '../components/filesRegisterIndicators/CountdownFiles.vue';
import CloseSession from "../components/general/CloseSession";
import Notification from '../components/general/Notification.vue';
import SideMenuAdministrator from "../views/administrator/SideMenu";
import SideMenuAdministrative from "../views/administrative/SideMenu";
import SideMenuManagementControl from '../views/management_control/SideMenu';
import Relogin from '../components/general/Relogin.vue';

export default {
  components: {
    CloseSession,
    SideMenuAdministrator,
    SideMenuManagementControl,
    Notification,
    CountdownFiles,
    SideMenuAdministrative,
    Relogin,
  },
  data() {
    return {
      drawer: true,
      global:process.env.VUE_APP_GLOBAL_VERSION,
      menu_role_id:JSON.parse(window.localStorage.getItem("user")).role_id
    };
  },
};
</script>